// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"112":"efb6b8a2","113":"8d765b97","265":"4e18720e","475":"10dd4e95","842":"1306cf44","923":"9e4bf3d5"}[chunkId] + ".css";
};